{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "user_action_log": "User Action Log",
    "bucket_history": "File Logs",
    "history": "History",
    "files": "Files",
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },

  "history": {
    "fromDate": "From Date",
    "toDate": "To Date",
    "title": "Bucket History",
    "clearAll": "Clear All",
    "downloadAll": "Download All",
    "search": "Search",
    "reset": "Reset",
    "path": "Path",
    "user": "User",
    "action": "Action",
    "searchPath": "Search by path",
    "searchUser": "Search by username",
    "searchAction": "Search by action",
    "loading": "Loading history...",
    "deleteTitle": "Delete Entry",
    "deleteConfirm": "Do you really want to delete this entry?",
    "delete": "Delete",
    "cancel": "Cancel",
    "clearAllTitle": "Clear All History",
    "clearAllConfirm": "This will permanently delete all bucket history entries. Continue?",
    "confirmDeleteAll": "Yes, delete all",
    "toastLoadError": "Failed to load history",
    "toastDeleteSuccess": "Entry deleted",
    "toastDeleteError": "Failed to delete entry",
    "toastClearSuccess": "History cleared",
    "toastClearError": "Failed to clear history",
    "toastDownloadError": "Failed to download history",
    "date": "Date"
  },

  "user_action": {
    "title": "User Action Log",
    "username": "Username",
    "action": "Action",
    "fromDate": "From Date",
    "toDate": "To Date",
    "search": "Search",
    "reset": "Reset",
    "searchUser": "Search by user",
    "searchAction": "Action type",
    "loading": "Loading logs...",
    "deleteTitle": "Delete Log Entry",
    "deleteConfirm": "Do you really want to delete this log entry?",
    "delete": "Delete",
    "cancel": "Cancel",
    "changeDetails": "Change Details",
    "toastFetchError": "Failed to fetch logs",
    "toastDeleteSuccess": "Log entry deleted",
    "toastDeleteError": "Failed to delete log entry"
  },

  "files": {
    "createFolderTitle": "Create Folder",
    "folderNameLabel": "Folder Name",
    "title": "Files",
    "uploading": "Uploading...",
    "upload": "Upload",
    "rootFolder": "Root-Folder",
    "confirmDeleteTitle": "Confirm Deletion",
    "confirmDeleteMessage": "Are you sure you want to delete",
    "confirmDeleteCancel": "Cancel",
    "confirmDeleteOk": "Delete",
    "createFolderLabel": "Folder Name",
    "createFolderCancel": "Cancel",
    "createFolderOk": "Create"
  },
  "user": {
    "add": "Add",
    "roles": "Roles",
    "actions": "Actions",
    "username": "Username",
    "email": "Email",
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "profile": {
    "username": "Username",
    "email": "Email",
    "password": "Password",
    "resetPassword": "Reset Password",
    "2faTitle": "Two-Factor Authentication",
    "2faModalTitle": "Two-Factor Authentication",
    "2faEnableInstruction": "Scan the QR code with your authenticator app, then enter the 6-digit code below.",
    "2faCodeLabel": "Authenticator Code",
    "2faCodePlaceholder": "Enter 6-digit code",
    "cancel": "Cancel",
    "enable2fa": "Enable 2FA",
    "disable2fa": "Disable 2FA",
    "setup2fa": "Set up 2FA",
    "2faEnabledText": "Two-Factor Authentication (2FA) is now enabled for your account, adding an extra layer of security to your sign-ins.",
    "2faDisabledText": "Add an extra layer of security to your account. To sign in, you’ll need to provide a code along with your username and password.",
    "2faEnabledToast": "2FA enabled successfully",
    "2faDisabledToast": "2FA disabled",
    "2faInitFailed": "Failed to initialize 2FA",
    "2faFailed": "2FA failed",
    "2faSuccessEnabled": "2FA successfully enabled",
    "2faSuccessDisabled": "2FA successfully disabled",
    "resetPasswordTitle": "Reset password",
    "oldPassword": "Old password",
    "newPassword": "New password",
    "repeatNewPassword": "Repeat new password",
    "otpCode": "2FA code",
    "otpPlaceholder": "Authenticator code",
    "updatePassword": "Update Password",

    "passwordSuccess": "You've successfully changed your password",
    "passwordErrorGeneric": "Something went wrong",
    "passwordUpdateFailed": "Update failed",

    "oldPasswordRequired": "Old password is required",
    "newPasswordRequired": "New password is required",
    "repeatNewPasswordRequired": "Repeat new password is required",
    "passwordsDoNotMatch": "Passwords do not match",

    "ruleMinLength": "Must be at least 8 characters long",
    "ruleUniqueChars": "Must contain at least 6 unique characters",
    "ruleDigit": "Must contain at least one digit",
    "ruleUppercase": "Must contain at least one uppercase letter",
    "ruleLowercase": "Must contain at least one lowercase letter",
    "ruleSpecialChar": "Must contain at least one special character",
    "ruleDifferentFromOld": "New password cannot be the same as old"
  },
  "settings": {
    "title": "Settings",
    "theme": "Theme",
    "general": "General preferences"
  },

  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  }
}
